module.exports = __webpack_public_path__ + "static/img/22-Wales-and-borders-rail-franchise.0e15d090.jpg";